/**
 * Route and settings tab → permission key mapping for UI guards.
 */

export const ROUTE_PERMISSIONS = {
  '/': 'tab_dashboard',
  '/jobs': 'tab_jobs',
  '/ai-studio': 'tab_resumes',
  '/resumes': 'tab_resumes',
  '/linkedin-studio': 'tab_resumes',
  '/matches': 'tab_matches',
  '/candidates': 'tab_candidates',
  '/timesheets': 'tab_timesheets',
  '/crm': 'tab_crm',
  '/metadata': 'tab_metadata',
  '/job-scanner': 'tab_job_scanner',
  '/email-queue': 'tab_email_queue',
  '/ai-watch': 'tab_ai_watch',
  '/product-analytics': 'tab_product_analytics',
  '/register': 'tab_register',
  '/support': 'tab_support',
  '/users': 'tab_users',
  '/settings': 'tab_settings',
};

export const SETTINGS_TAB_PERMISSIONS = {
  profile: null,
  theme: null,
  endpoints: 'view_all_data',
  users: 'tab_users',
  roles: 'permission_manage',
  groups: 'group_manage',
  permissions: 'permission_manage',
  'ai-matching': 'ai_matching_manage',
  'linkedin-api': 'ai_matching_manage',
  scanner: 'scanner_manage',
  'resume-templates': 'ai_matching_manage',
  ocr: 'ai_matching_manage',
  email: 'email_manage',
};

export function permissionForPath(pathname) {
  if (!pathname) return null;
  const base = pathname.split('?')[0];
  if (ROUTE_PERMISSIONS[base]) return ROUTE_PERMISSIONS[base];
  const segments = base.split('/').filter(Boolean);
  if (segments.length >= 1) {
    const root = `/${segments[0]}`;
    return ROUTE_PERMISSIONS[root] || null;
  }
  return null;
}

/** First usable app path for the signed-in user (avoids Access Denied for support-only roles). */
export function getDefaultAppPath(hasPermission) {
  const check = typeof hasPermission === 'function' ? hasPermission : () => false;
  const candidates = [
    ['tab_dashboard', '/'],
    ['tab_support', '/support'],
    ['tab_jobs', '/jobs'],
    ['tab_candidates', '/candidates'],
    ['tab_settings', '/settings'],
  ];
  for (const [perm, path] of candidates) {
    if (check(perm)) return path;
  }
  return '/';
}
